import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/laboratorio';
import LaboratoriosSolidoList from './LaboratoriosList';

const ms2p = (state) => {
  return {
    ...state.laboratorio,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(LaboratoriosSolidoList);
